import { render } from "./StockToZeroButton.vue?vue&type=template&id=63a7f07f"
import script from "./StockToZeroButton.vue?vue&type=script&lang=js"
export * from "./StockToZeroButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__